import React, { useRef } from "react";
import { Box } from "arkh";
import { ProductSearch } from "./ProductSearch";
import { isInputEAN } from "../ProductExpireBatch/isInputEAN";
import { isInputFromScan } from "../ProductExpireBatchCreate/isInputFromScan";
import {
  UserLoggedInNavigatorNavigationProp,
  UserLoggedInNavigatorScreenProps,
} from "../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { withWebModal } from "@/src/TopLevelNavigators/UserLoggedIn/withWebModal";
import {
  createNativeStackNavigator,
  NativeStackNavigationProp,
} from "@react-navigation/native-stack";
import { CompositeNavigationProp } from "@react-navigation/native";
import { useNavigationHeaderOptions } from "../../common/navigationHeaderOptions";
import {
  DEVICE_HAS_SCANNER,
  ScanToOpenProductLabel,
} from "../Product/ScanToAddExpireDate";
import { useIntlTokens } from "../../components/mobile/useIntlTokens";

type ParamList = {
  ProductSearchMain: object;
};
const Stack = createNativeStackNavigator<ParamList>();

function ProductSearchMain(props: {
  navigation: CompositeNavigationProp<
    UserLoggedInNavigatorNavigationProp<"Products">,
    NativeStackNavigationProp<ParamList, "ProductSearchMain">
  >;
}) {
  const [searchOpen, setSearchOpen] = React.useState(false);
  const [query, setQuery] = React.useState("");

  const prevText = useRef("");

  return (
    <>
      <Box color="surface-background-light" style={{ flex: 1 }}>
        <ProductSearch
          query={query}
          autoFocus
          onChange={(e) => {
            if (
              isInputFromScan(e.nativeEvent.text, prevText.current) &&
              isInputEAN(e.nativeEvent.text.slice(prevText.current.length))
            ) {
              const ean = e.nativeEvent.text.slice(prevText.current.length);
              prevText.current = "";
              setQuery("");
              props.navigation.navigateDeprecated("Product", {
                screen: "ProductMain",
                params: {
                  ean,
                  type: "ean",
                  state: "details",
                },
              });
            } else {
              prevText.current = e.nativeEvent.text;
              setQuery(e.nativeEvent.text);
            }
          }}
          onFocus={() => {
            setSearchOpen(true);
          }}
          onBlur={() => {
            setSearchOpen(false);
          }}
          onPressProduct={(product) => {
            props.navigation.navigateDeprecated("Product", {
              screen: "ProductMain",
              params: {
                id: product.id,
                type: "id",
                state: "details",
              },
            });
          }}
          isSearching={searchOpen}
        />
      </Box>
    </>
  );
}

export const Products = withWebModal(
  (props: UserLoggedInNavigatorScreenProps<"Products">) => {
    const getOptions = useNavigationHeaderOptions();
    const intl = useIntlTokens();
    return (
      <Stack.Navigator>
        <Stack.Screen
          name="ProductSearchMain"
          component={ProductSearchMain}
          options={getOptions({
            type: "CLOSE",
            onClose: () => {
              props.navigation.goBack();
            },
            headerTitle: DEVICE_HAS_SCANNER
              ? () => <ScanToOpenProductLabel />
              : intl.Products,
          })}
        />
      </Stack.Navigator>
    );
  },
  true,
  {}
);
